<template>
  <b-card no-body class="wrapper">
    <b-card-body>
      <b-card-text>
        <div class="label">Unavailable Reason</div>
        <div class="text">
          <b-form-select
            id="answer"
            v-model="selectedReason"
            :options="UnavailableReasons"
            value-field="id"
            text-field="name"
          >
            <template #first>
              <b-form-select-option :value="null">Please Select</b-form-select-option>
            </template>
            <b-form-select-option value="NA">No Answer</b-form-select-option>
            <b-form-select-option value="1D">DM Unavailable - 1 day</b-form-select-option>
            <b-form-select-option value="1W">DM unavailable - 1 week</b-form-select-option>
            <b-form-select-option value="2W">DM unavailable - 2 weeks</b-form-select-option>
            <b-form-select-option value="1M">DM unavailable - 1 month</b-form-select-option>
          </b-form-select>
        </div>

        <div class="text">
          <b-button class="mt-3" variant="success" block @click="saveReason" :disabled="!selectedReason">
            <font-awesome-icon icon="check" /> Confirm
          </b-button>

          <b-button
            class="mt-3"
            variant="danger"
            block
            @click="$parent.showDispositions">
            <font-awesome-icon icon="times" /> Cancel
          </b-button>
        </div>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import DataSelectionService from "@/services/DataSelection.service";

export default {
  name: "UnavailableReason",
  props: {
    companyId: String
  },
  data() {
    return {
      selectedReason: null
    };
  },
  methods: {
    saveReason() {

      this.$http.post("/company/unavailable/",
        {
          companyId: this.companyId,
          UnavailableReason: this.selectedReason,
          UnavailableReasonText: this.selectedReason
        }).then(() => {
          if(this.$route.name == "CompanyCall") {
            DataSelectionService.getNextCompany().then(result => {
              if(result && result.data != 0) {
                this.$router.push("/call/" + result.data);
              } else {
                this.$router.push("/getnext");
              }
            });
          } else {
            this.$parent.$parent.loadData();
            this.$parent.showDispositions();
          }
      });
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
.wrapper {
  margin-top: 10px;
}
</style>
